import {
  BranchPermissionStatus,
  Permission,
} from '../../../../../api/types/user/permissions/update-user-permission-request';
import { toast } from 'react-toastify';
import { SettingsBranches } from '../../../../../api/types/settings/branches/settings-branches';
import appApi from '../../../../../api/app-api';

export const updateUserPermissions = async (
  userId: number,
  permissions: Permission[],
  branches: BranchPermissionStatus[],
) => {
  try {
    if (!Array.isArray(permissions) || permissions.length === 0) {
      toast.warn('תחילה יש לבצע שינוי');
      return;
    }
    const asd = await appApi.updateUserPermissions(
      userId,
      permissions,
      branches,
    );
    // TODO api call
    toast.success('הפעולה בתהצלעה בהצלחה');
  } catch (e) {
    console.log(`Can't update user permission with the error: ${e}`);
    toast.error('לא ניתן לבצע את השינוי המבוקש, נשסה שוב בעוד מספר רגעים');
  }
};
